import * as Sentry from "@sentry/browser";

const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();

if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    debug: import.meta.env.VITE_SENTRY_DEBUG === "true",
  });

  if (import.meta.env.DEV) {
    window.__pathimoSentryTest = () => {
      const id = Sentry.captureMessage("Pathimo Sentry bağlantı testi", "info");
      return id;
    };
  }
} else if (import.meta.env.DEV) {
  console.warn(
    "[Sentry] VITE_SENTRY_DSN yok veya boş — Sentry.init çağrılmadı, olaylar gönderilmez. .env içine DSN ekleyip `npm run dev` ile sunucuyu yeniden başlatın.",
  );
}
